import moment from 'moment';
import {RecallsAppModel, Recall, RecallStatus} from '../typings/general';
import * as general from './general';

/**
 * Format modified date by 'dddd,MMM DD, YYYY'
 * @param dateString
 */
export const formatModifiedDate = (dateString: string) => {
  return moment(dateString).format('dddd, MMM DD, YYYY');
};

/**
 * get formated date by 'MM-DD-YYYY'
 * @param dateString
 */
export const getFormmatedDate = (dateString: string) => {
  return moment(dateString).format('MM-DD-YYYY');
};

/**
 * Return recall status given by status number;
 * @param statusNum
 */
export const getRecallStatus = (statusNum: number): [RecallStatus, boolean] => {
  switch (statusNum) {
    case 11:
      return [RecallStatus.REPAIR_NEEDED, true];
    case 12:
      return [RecallStatus.REPAIR_NOT_YET_AVAILABLE, false];
    case 13:
      return [RecallStatus.RECALL_COMPLETE, false];
    default:
      return [RecallStatus.UNKNOW_STATUS, false];
  }
};

// Mapping error messages
export const errorMessage: any = {
  62: 'This vehicle was built for the Canadian market. Please go to www.vw.ca for further information on Canadian vehicles.',
  64: 'This vehicle was built for the Canadian market. Please go to www.audi.ca for further information on Canadian vehicles.',
  72: 'You have entered an Audi VIN. Please go to www.audiusa.com.',
  74: 'You have entered a Volkswagen VIN. Please go to www.vw.com.',
  91: 'This is not a recognizable Volkswagen VIN. Please check your VIN and try again.',
  92: 'Server Error in ProductComplianceActionStatusService',
  93: 'Api Key Mismatch',
  100: 'Server error in Recall Service'
};

/**
 * process recalls, and separate safety and other recalls
 * @param recalls
 */
export const processRecalls = (recalls: RecallsAppModel): RecallsAppModel => {
  const serviceRecalls: Recall[] = [];
  const safetyRecalls: Recall[] = [];
  if (recalls.errorCode) recalls.errorMessage = errorMessage[recalls.errorCode];
  recalls.recalls?.map((recall: Recall) => {
    recall.startDate = general.getFormmatedDate(recall.recallDate);
    recall.status = general.getRecallStatus(recall.mfrRecallStatus)[0];
    recall.statusImportant = general.getRecallStatus(recall.mfrRecallStatus)[1];
    recall.vwgoaActionType === 'SAFETY'
      ? safetyRecalls.push(recall)
      : serviceRecalls.push(recall);
  });

  recalls.safetyRecalls = safetyRecalls;
  recalls.serviceRecalls = serviceRecalls;
  return recalls;
};
